import React, { useState, useEffect } from "react";

import { useNavigate } from 'react-router-dom';
import { connect } from "react-redux";
import { useSelector } from "react-redux";
import { IoArrowBackOutline } from "react-icons/io5";

import {
  selectTemplate,
  setTemplateType,
  selectSection,
  changeInputData,
  getAllTemplates,
  getTemplateContent,
  clearHistory,
  clearPreview,
  clearTemplate,
  selectArticleForTemplate,
  selectBlogForTemplate,
  selectEvaluationForTemplate,
  clearArticleTitle,
  setOpen,
  setTemplateToDelete,
  setPossibleRoute,
  setSelectedAction,
} from "../../redux/actions/articleTemplates";
import { setAlert } from "../../redux/actions/alerts";

import styles from '../../styles/pages/Template.module.css';

const TrashIcon = '/static/img/SvgIcons/icons-trash-black.svg';

const TemplateSidebar = ({
  selectTemplate,
  setTemplateType,
  selectSection,
  changeInputData,
  getAllTemplates,
  getTemplateContent,
  clearHistory,
  clearPreview,
  clearTemplate,
  clearArticleTitle,
  selectArticleForTemplate,
  selectBlogForTemplate,
  selectEvaluationForTemplate,
  setOpen, setTemplateToDelete,
  setPossibleRoute,
  setSelectedAction,
  onClose,
  articleTemplate: {
    selectedTemplate,
    selectedArticle,
    selectedEvaluation,
    selectedBlog,
    sections,
    inputtedData,
    templates,
    returnUrl,
    selectedSection,
    templateType,
    open,
    templateToDelete,
    possibleRoute,
  },
}) => {


  const navigate = useNavigate()
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    getAllTemplates()
  }, [])

  useEffect(() => {
    if (selectedArticle) {
      setTemplateType('article')
      getTemplateContent(selectedArticle?.article_id, 'article')

    } else if (selectedEvaluation) {
      setTemplateType('evaluation')
      getTemplateContent(selectedEvaluation?.product_evaluation_id, 'evaluation')

    } else if (selectedBlog) {
      setTemplateType('blog')
      getTemplateContent(selectedBlog?.entryId, 'blog')

    }
  }, [selectedArticle, selectedEvaluation, selectedBlog])

  const handleClose = () => {
    setSelectedAction('')
    setOpen(false)

    if (templateToDelete) {
      setTemplateToDelete(null)
    }

    if (possibleRoute) {
      setPossibleRoute(null)
    }

    if (selectedSection) {
      selectSection(null)
    }
  }

  const addInputData = (section, order, existingData) => {
    if (!section) {
      return
    }
    const existingComponent = existingData[section.component]
    const childrenStyles = section.children_styles_options.map(option => ({ name: option.name, styles: '' }))
    if (existingComponent) {

      return {
        ...existingData,
        [section.component]: [
          ...existingData[section.component],
          {
            component_id: section.component_id,
            component_version: section.component_version,
            order: order,
            children: [...JSON.parse(JSON.stringify(section.children))],
            styles: '',
            children_styles: childrenStyles
          }
        ]
      }

    } else {
      return {
        ...existingData,
        [section.component]: [
          {
            component_id: section.component_id,
            component_version: section.component_version,
            order: order,
            children: [...JSON.parse(JSON.stringify(section.children))],
            styles: '',
            children_styles: childrenStyles
          }
        ]
      }

    }
  }

  const handleAddTemplate = (template) => {
    if (selectedTemplate) {
      return
    }

    selectTemplate(template)

    if (template.template_name === 'Custom') {
      return
    }

    let existingData = { ...inputtedData }
    for (let i = 0; i < template.json?.length; i++) {
      existingData = addInputData(template.json[i], i, existingData)

    }
    changeInputData(existingData)

  }

  const handleClickTemplateDelete = (template) => {
    if (selectedTemplate) {
      return
    }
    
    setOpen(true)
    setTemplateToDelete(template)
    setSelectedAction('delete')
  }

  const confirmNavigation = (route) => {
    if (sections.length > 0) {
      setOpen(true)
      setSelectedAction('confirm-navigation')
      setPossibleRoute(route)
    } else {
      handleNavigation(route)
    }
  }

  const handleNavigation = (route) => {
    setPossibleRoute(null)
    clearArticleTitle()
    clearHistory()
    selectTemplate(null)
    selectArticleForTemplate(null)
    selectBlogForTemplate(null)
    selectEvaluationForTemplate(null)
    clearTemplate()
    clearPreview()

    if (open) {
      setOpen(false)
    }
    if (route === 'home') {
      navigate('/')
    } else if (route === 'back') {

      navigate(returnUrl ? returnUrl : '/onsite-content')
    }
    handleClose()

  }

  const handleSwitchTemplateType = (newTemplateType) => {
    if (selectedTemplate) {
      return
    }

    if (newTemplateType === templateType) {
      setTemplateType(null)
    } else {
      setTemplateType(newTemplateType)
    }
  }
  
  const SidebarSection = ({ sectionType, sectionSelected, selectedTemplate, handleSwitchTemplateType, handleAddTemplate, handleClickTemplateDelete, templates, isDisabled }) => {
    const sectionTemplates = templates?.length > 0 ? [...templates.filter(template => template.template_category === sectionType), { template_name: "Custom" }] : [{ template_name: "Custom" }]

    return (
      <div className={`${styles.template_sidebar_section} ${sectionSelected ? styles.template_sidebar_section_selected : ''}`}>

        <div className={`${styles.template_sidebar_section_header} ${isDisabled ? styles.template_sidebar_disabled : ''}`} onClick={() => isDisabled ? {} : handleSwitchTemplateType(sectionType)}>
          <p >{sectionType[0].toUpperCase() + sectionType.slice(1)} Templates</p>
        </div>

        <div>

          {sectionSelected ?
            sectionTemplates.map((temp, i) => {
              const disabled = !auth.accountUser?.hasAccess.includes('blogsAndArticles') || isDisabled
              return (
              <div key={`sidebar-${i}`} className={`${styles.template_sidebar_sub_section} ${selectedTemplate?.template_name === temp.template_name ? styles.template_sidebar_sub_section_selected : ''} ${disabled ? styles.template_sidebar_disabled : ''}`}>
                <p  onClick={() => disabled ? {} : handleAddTemplate(temp)}>{temp.template_name}</p>
                
                {temp.template_id ? 
                  <img src={TrashIcon} alt="Trash Icon"  onClick={() => disabled ? {} : handleClickTemplateDelete(temp)}/>
                : null}

              </div>
            )})
          : null}

        </div>
      </div>
    )
  }
  
  return (
    <div className={styles.template_sidebar}>

      <div className={styles.template_sidebar_section}>
        <div onClick={() => confirmNavigation('back')} className={`${styles.template_sidebar_section_header}`}>
          <IoArrowBackOutline size={25} />
          <p >Back to CMS</p>
        </div>

      </div>
      {selectedTemplate ?
        <button className={`${styles.template_page_switch_button} ${styles.template_sidebar_switch_button}`} onClick={() => confirmNavigation('switch')}>Switch Layout</button>
      : null}

      <SidebarSection
        sectionType={'article'}
        sectionSelected={templateType === 'article'}
        selectedTemplate={selectedTemplate}
        handleSwitchTemplateType={handleSwitchTemplateType}
        handleAddTemplate={handleAddTemplate}
        handleClickTemplateDelete={handleClickTemplateDelete}
        templates={templates}
        isDisabled={selectedTemplate ? true : false}
      />
      <SidebarSection
        sectionType={'blog'}
        sectionSelected={templateType === 'blog'}
        selectedTemplate={selectedTemplate}
        handleSwitchTemplateType={handleSwitchTemplateType}
        handleAddTemplate={handleAddTemplate}
        handleClickTemplateDelete={handleClickTemplateDelete}
        templates={templates}
        isDisabled={selectedTemplate ? true : false}
      />
      <SidebarSection
        sectionType={'evaluation'}
        sectionSelected={templateType === 'evaluation'}
        selectedTemplate={selectedTemplate}
        handleSwitchTemplateType={handleSwitchTemplateType}
        handleAddTemplate={handleAddTemplate}
        handleClickTemplateDelete={handleClickTemplateDelete}
        templates={templates}
        isDisabled={selectedTemplate ? true : false}
      />
      <div className={styles.template_sidebar_backdrop} onClick={onClose}></div>
    </div>
   
  );
};

const mapStateToProps = (state) => ({
  articleTemplate: state.articleTemplate
});

export default connect(mapStateToProps, {
  selectTemplate,
  setTemplateType,
  selectSection,
  changeInputData,
  setAlert,
  getAllTemplates,
  getTemplateContent,
  clearHistory,
  clearPreview,
  clearTemplate,
  selectArticleForTemplate,
  selectBlogForTemplate,
  selectEvaluationForTemplate,
  clearArticleTitle,
  setOpen,
  setTemplateToDelete,
  setPossibleRoute,
  setSelectedAction,
})(TemplateSidebar);